import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const StatsContainer = styled.section`
  background: var(--primary-color);
  color: var(--white-color);
  padding: 80px 0;
  
  @media (max-width: 768px) {
    padding: 60px 0;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  text-align: center;
`;

const StatItem = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StatNumber = styled.div`
  font-size: 3.5rem;
  font-weight: 700;
  margin-bottom: 10px;
  line-height: 1;
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const StatLabel = styled.div`
  font-size: 1.2rem;
  font-weight: 500;
  opacity: 0.9;
  
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const StatDescription = styled.div`
  font-size: 0.9rem;
  opacity: 0.8;
  margin-top: 5px;
  
  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`;

const StatsSection = () => {
  const [ref, inView] = useInView({
    threshold: 0.3,
    triggerOnce: true
  });

  const stats = [
    {
      number: 25,
      label: "Yıllık Tecrübe",
      description: "Sektörde güvenilir hizmet"
    },
    {
      number: 120,
      label: "Profesyonel Ekip",
      description: "Uzman kadro"
    },
    {
      number: 15000,
      label: "Başarılı İşlem",
      description: "Müşteri memnuniyeti"
    },
    {
      number: 100,
      label: "Kalite Yüzdesi",
      description: "Mükemmel hizmet"
    }
  ];

  const countUp = (end, duration = 2000) => {
    return {
      from: 0,
      to: end,
      duration: duration / 1000,
      ease: "easeOut"
    };
  };

  return (
    <StatsContainer>
      <Container>
        <StatsGrid ref={ref}>
          {stats.map((stat, index) => (
            <StatItem
              key={index}
              initial={{ opacity: 0, y: 50 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <StatNumber>
                {inView ? (
                  <motion.span
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.6, delay: index * 0.1 }}
                  >
                    {stat.number}
                  </motion.span>
                ) : (
                  stat.number
                )}
              </StatNumber>
              <StatLabel>{stat.label}</StatLabel>
              <StatDescription>{stat.description}</StatDescription>
            </StatItem>
          ))}
        </StatsGrid>
      </Container>
    </StatsContainer>
  );
};

export default StatsSection; 